<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px" align="center">
          <v-col cols="3">
            <h3>تقرير الطلبة غير المسددين</h3>
          </v-col>
          <v-col cols="3">
            <v-select v-model="reportType" :items="reportTypes" item-text="name" item-value="value" label="نوع التقرير" outlined dense hide-details @change="loadData"></v-select>
          </v-col>
          <v-col cols="3">
            <v-select v-model="selectedSection" :items="sections" item-text="sectionName" item-value="sectionName" label="القسم" outlined dense hide-details clearable></v-select>
          </v-col>
          <v-col cols="3">
            <v-btn color="success" @click="exportToExcel" :loading="exporting" :disabled="filteredData.length === 0" block>
              <v-icon left>mdi-file-excel</v-icon>
              تصدير Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid v-if="filteredData.length > 0">
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="6">
            <h4>عدد الطلبة: {{ filteredData.length.toLocaleString("en-US") }}</h4>
          </v-col>
          <v-col cols="6">
            <h4 style="color: red; font-weight: 700">المجموع الكلي: {{ sumExpectedAmount.toLocaleString("en-US") }}</h4>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-card-title>
          <v-text-field v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="filteredData" :items-per-page="15" :search="search" class="table-content">
          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>

          <template v-slot:[`item.expectedAmount`]="{ item }">
            <p style="padding: 0 3px; font-weight: 600">{{ item.expectedAmount.toLocaleString("en-US") }}</p>
          </template>

          <template v-slot:[`body.append`]>
            <tr style="background: #E8F5E9; font-weight: 700">
              <td colspan="6" style="text-align: center; padding: 8px">المجموع</td>
              <td style="padding: 8px; color: red">{{ sumExpectedAmount.toLocaleString("en-US") }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "UnpaidReport",
  data: () => ({
    overlay: false,
    exporting: false,
    search: "",
    students: [],
    selectedSection: null,
    reportType: "identity",
    reportTypes: [
      { name: "غير مسددي الهوية", value: "identity" },
      { name: "غير مسددي الخدمات الجامعية", value: "services" },
    ],
    headers: [
      { text: "ت", value: "index", width: 50 },
      { text: "اسم الطالب", value: "studentName" },
      { text: "الرقم الجامعي", value: "collegeNumber" },
      { text: "القسم", value: "sectionName" },
      { text: "حالة الطالب", value: "statusName" },
      { text: "سنة التسجيل", value: "registerYearName" },
      { text: "المبلغ", value: "expectedAmount" },
    ],
  }),
  computed: {
    sections() {
      const sectionMap = {};
      this.students.forEach((s) => {
        if (!sectionMap[s.sectionName]) {
          sectionMap[s.sectionName] = { sectionName: s.sectionName };
        }
      });
      return Object.values(sectionMap);
    },
    filteredData() {
      return this.students.filter((s) => {
        if (this.selectedSection && s.sectionName !== this.selectedSection) return false;
        return true;
      });
    },
    reportTitle() {
      return this.reportType === "identity" ? "غير مسددي الهوية" : "غير مسددي الخدمات الجامعية";
    },
    sumExpectedAmount() {
      return this.filteredData.reduce((sum, s) => sum + (Number(s.expectedAmount) || 0), 0);
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      let self = this;
      self.overlay = true;
      const endpoint = self.reportType === "identity" ? "getUnpaidIdentityReport" : "getUnpaidServicesReport";

      self.$http
        .get(`${self.$store.state.apiUrlFees}/${endpoint}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          self.students = res.data;
          self.overlay = false;
        })
        .catch((e) => {
          console.log(e);
          self.overlay = false;
          self.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
        });
    },
    async exportToExcel() {
      this.exporting = true;
      try {
        const exportData = this.filteredData.map((s, i) => ({
          ت: i + 1,
          "اسم الطالب": s.studentName,
          "الرقم الجامعي": s.collegeNumber,
          القسم: s.sectionName,
          "حالة الطالب": s.statusName,
          "سنة التسجيل": s.registerYearName,
          المبلغ: s.expectedAmount,
        }));

        const ExcelJS = await import("exceljs");
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(this.reportTitle);

        const headers = Object.keys(exportData[0]);
        worksheet.addRow(headers);

        exportData.forEach((row) => {
          worksheet.addRow(Object.values(row));
        });

        const totalsRow = worksheet.addRow(["", "المجموع", "", "", "", "", this.sumExpectedAmount]);
        totalsRow.font = { bold: true };
        totalsRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE8F5E9" },
        };

        worksheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
        worksheet.getRow(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF0E734B" },
        };

        worksheet.columns.forEach((column) => {
          column.width = 20;
        });
        worksheet.getColumn(1).width = 6;
        worksheet.getColumn(2).width = 30;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${this.reportType}_unpaid_report.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

        this.$toasted.success("تم تصدير البيانات بنجاح");
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.$toasted.error("حدث خطأ في تصدير البيانات");
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
